// import { useTranslations } from 'next-intl';

'use client';

import {usePathname} from 'next/navigation';

import Footer from '@/components/global/Footer';
import Header from '@/components/global/Header';
import {PartnerBanner} from '@/components/global/PartnerBanner';

export default function Layout(props: { children: React.ReactNode }) {
    // const t = useTranslations('RootLayout');
    const pathname = usePathname();

    return (
        <>
            <div className="flex h-screen flex-col">
                {/* Dynamic partner banner - only shows on partner domains */}
                <PartnerBanner />
                <Header/>

                <div className="flex-auto overflow-y-auto bg-background">
                    <div className="container min-h-[70vh] pt-5 text-xl max-sm:p-3 [&_p]:my-1">
                        {props.children}
                    </div>
                    {/* <Footer /> */}
                    {pathname.includes('/checkout') ? null : <Footer/>}
                </div>
            </div>
        </>
    );
}
